import { render, staticRenderFns } from "./UserRoute.vue?vue&type=template&id=4dca39dc&scoped=true"
import script from "./UserRoute.vue?vue&type=script&lang=ts"
export * from "./UserRoute.vue?vue&type=script&lang=ts"
import style0 from "./UserRoute.vue?vue&type=style&index=0&id=4dca39dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dca39dc",
  null
  
)

export default component.exports